module.exports = __webpack_public_path__ + "static/img/icon_zj_07.6a39fd6a.png";